/**
 * Room-tint helpers shared by `GalleryCard`/`GalleryListRow`. `classic` rooms
 * are fixed hand-authored `.babylon` meshes with no configurable wall/floor
 * color (unlike `studio`'s `SCENE_PRESET_GEOMETRY`), so there's no "real"
 * tint to fall back on before the scene note loads — this is a deliberate
 * neutral stand-in, distinct from every `studio` preset so the two modes
 * never look identical while a card is still loading.
 */
export const CLASSIC_ROOM_TINT = { wallColor: '#3a3a40', floorColor: '#24242a' }

/** Relative-luminance check — used to pick dark-on-light ghost-frame/label styling for pale rooms (e.g. Pavilion) instead of hardcoding one hex. */
export function isLightColor(hex: string): boolean {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (!m) return false
  const [r, g, b] = [m[1], m[2], m[3]].map((h) => parseInt(h, 16) / 255)
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b
  return luminance > 0.6
}
